import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "../../constant";

const getToken = () => {
  const userToken = localStorage.getItem("userToken");
  return userToken ? `Bearer ${userToken}` : "";
};

const followupApi = createApi({
  reducerPath: "fetchfollowapi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    mode: "cors",
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set("Authorization", token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getListView: builder.query({
      query: (id) => ({
        url: `mylead/followups?id=${id}`,
        method: "GET",
      }),
    }),

    getNextfollowUp: builder.query({
      query: (id) => ({
        url: `nextfollowup?user_id=${id}`,
        method: "GET",
      }),
    }),
    getOptionList: builder.query({
      query: () => ({
        url: `static-value`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetNextfollowUpQuery,
  useGetListViewQuery,
  useGetOptionListQuery,
  useFilterListQuery,
} = followupApi;
export default followupApi;
